components: {
LogoSystem,
},<template>
    <div class="auth-wrapper d-flex align-items-center justify-content-center">
        <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1060">
            <transition-group name="slide-fade">
                <div v-for="alert in alerts" :key="alert.id" class="toast show border-0 shadow-lg mb-2"
                    :class="alert.type === 'success' ? 'bg-success-subtle text-success' : 'bg-error-subtle text-danger'">
                    <div class="d-flex p-3">
                        <i class="me-3 fs-5"
                            :class="alert.type === 'success' ? 'bi bi-check-circle-fill' : 'bi bi-x-circle-fill'"></i>
                        <div class="toast-body p-0 fw-medium">{{ alert.message }}</div>
                        <button type="button" class="btn-close ms-auto" @click="removeAlert(alert.id)"></button>
                    </div>
                </div>
            </transition-group>
        </div>
        <div class="auth-card card border-0 shadow-lg rounded-4 overflow-hidden">
            <div class="row g-0 h-100">
                <div
                    class="col-lg-5 d-none d-lg-flex flex-column justify-content-center align-items-center bg-primary-pmg p-5 text-white text-center">
                     <LogoSystem  height="300px"  style="transform: scale(2.4); margin-top: -30px; margin-bottom: 10px; margin-right: 100px;" />
                    <p class="opacity-75 small text-black mt-5">Menos burocracia, mais eficiência: seus dados em um só
                        lugar.</p>
                </div>
                <div class="col-lg-7 p-4 p-md-5 bg-white position-relative">
    
    <!-- FLUXO DE LOGIN (Padrão) -->
    <div v-if="!isResettingPassword">
        <div class="mb-5 text-center text-lg-start">
            <h3 class="fw-bold text-dark">Bem-vindo de volta</h3>
            <p class="text-muted">Insira suas credenciais para acessar o painel.</p>
        </div>
        
        <form @submit.prevent="handleLogin">
            <div class="mb-4">
                <label class="form-label small fw-bold text-muted text-uppercase">E-mail</label>
                <div class="input-group">
                    <span class="input-group-text bg-light border-end-0 rounded-start-3 text-muted">
                        <i class="bi bi-envelope"></i>
                    </span>
                    <input v-model="form.email" type="email" class="form-control form-control-pmg border-start-0 ps-0" placeholder="usuario@dominio.com" required>
                </div>
            </div>
            <div class="mb-3">
                <div class="d-flex justify-content-between align-items-center mb-1">
                    <label class="form-label small fw-bold text-muted text-uppercase mb-0">Senha</label>
                    <!-- ADICIONADO O EVENTO DE CLICK AQUI -->
                    <a href="#" @click.prevent="isResettingPassword = true" class="text-primary-pmg text-decoration-none x-small fw-bold">Esqueceu a senha?</a>
                </div>
                <div class="input-group">
                    <span class="input-group-text bg-light border-end-0 rounded-start-3 text-muted">
                        <i class="bi bi-lock"></i>
                    </span>
                    <input v-model="form.password" :type="showPassword ? 'text' : 'password'" class="form-control form-control-pmg border-start-0 ps-0" placeholder="••••••••" required>
                    <button class="btn btn-light border border-start-0 rounded-end-3 text-muted" type="button" @click="showPassword = !showPassword">
                        <i :class="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                    </button>
                </div>
            </div>
            <button type="submit" class="btn btn-pmg-primary w-100 py-3 fw-bold rounded-3 shadow-sm mb-3" :disabled="loading || !isFormValid">
                <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                {{ loading ? 'Autenticando...' : 'Entrar no Sistema' }}
            </button>
        </form>
    </div>

    <!-- FLUXO DE RECUPERAÇÃO DE SENHA -->
    <div v-else>
        <div class="mb-5 text-center text-lg-start">
            <h3 class="fw-bold text-dark">Recuperar Senha</h3>
            <p class="text-muted">Informe seu e-mail cadastrado e enviaremos uma nova senha de acesso.</p>
        </div>
        
        <form @submit.prevent="handleResetPassword">
            <div class="mb-4">
                <label class="form-label small fw-bold text-muted text-uppercase">E-mail Cadastrado</label>
                <div class="input-group">
                    <span class="input-group-text bg-light border-end-0 rounded-start-3 text-muted">
                        <i class="bi bi-envelope"></i>
                    </span>
                    <input v-model="resetEmail" type="email" class="form-control form-control-pmg border-start-0 ps-0" placeholder="usuario@dominio.com" required>
                </div>
            </div>
            
            <button type="submit" class="btn btn-pmg-primary w-100 py-3 fw-bold rounded-3 shadow-sm mb-3" :disabled="loadingReset || !isResetValid">
                <span v-if="loadingReset" class="spinner-border spinner-border-sm me-2"></span>
                {{ loadingReset ? 'Enviando...' : 'Enviar Nova Senha' }}
            </button>
            
            <button type="button" @click="isResettingPassword = false" class="btn btn-light w-100 py-3 fw-bold rounded-3 shadow-sm text-muted" :disabled="loadingReset">
                Voltar para o Login
            </button>
        </form>
    </div>
    
    <p class="text-center text-muted small mt-4">
        Não tem uma conta? <a href="https://wa.me/5551995885470?text=Ol%C3%A1!%20Voc%C3%AA%20deseja%20saber%20mais%20sobre..." class="text-primary-pmg fw-bold text-decoration-none" target="_blank">Entrar em contato</a>
    </p>
</div>
            </div>
        </div>
    </div>
</template>

<script>
// Importa o arquivo de configuração da API que acabamos de criar
import api from '@/services/api';
import LogoSystem from '@/LogoSystem.vue'

export default {
    name: 'LoginScreen',
    components: { LogoSystem },
    data() {
        return {
            form: {
                email: '',
                password: '',
                remember: false
            },
            showPassword: false,
            loading: false,
            alerts: [],
            isResettingPassword: false,
            resetEmail: '',
            loadingReset: false
        }
    },

    computed: {
        // Validação simples: e-mail deve ter '@' e senha no mínimo 6 caracteres
        isFormValid() {
            return this.form.email.includes('@') && this.form.password.length >= 6;
        },
        isResetValid() {
            return this.resetEmail.includes('@') && this.resetEmail.length > 5;
        }
    },

    mounted() {
        const urlParams = new URLSearchParams(window.location.search);

        if (urlParams.has('expired')) {
            this.showAlert("Sua sessão expirou por inatividade. Faça login novamente.", "error");
            const cleanUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
            window.history.replaceState({ path: cleanUrl }, '', cleanUrl);
        }

        if (urlParams.has('loggedOut')) {
            this.showAlert("Sessão encerrada com sucesso.", "success");
            const cleanUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
            window.history.replaceState({ path: cleanUrl }, '', cleanUrl);
        }
    },
    methods: {
        async handleLogin() {
            this.loading = true;

            try {
                const response = await api.post('/login', {
                    email: this.form.email,
                    password: this.form.password
                });
                const name = response.data.name || response.data.user.name;
                const email = response.data.email || response.data.user.email;
                const token = response.data.token || response.data.access_token;

                if (token) {
                    localStorage.setItem('access_token', token);
                    localStorage.setItem('name',name);
                    localStorage.setItem('email',email);
                    this.$router.push('/categorias');
                } else {
                    throw new Error("Token não retornado.");
                }

            } catch (error) {
                // Exibe a mensagem personalizada de erro diretamente no layout
                this.showAlert("Usuário e/ou senha inválido(s).");

                // Limpa a senha para o usuário tentar novamente (opcional, mas recomendado)
                this.form.password = '';
            } finally {
                this.loading = false;
            }
        },

        showAlert(message, type = 'error') {
            const id = Date.now();
            this.alerts.push({ id, message, type });
            setTimeout(() => this.removeAlert(id), 5000);
        },

        removeAlert(id) {
            this.alerts = this.alerts.filter(a => a.id !== id);
        },
        async handleResetPassword() {
            this.loadingReset = true;

            try {
                // Chama o endpoint que criamos anteriormente
                const response = await api.post('/auth/reset-password', {
                    email: this.resetEmail
                });

                // Mostra a mensagem de sucesso que veio da API
                this.showAlert(response.data.message || "Senha redefinida! Verifique seu e-mail.", "success");
                
                // Limpa o campo e volta para a tela de login
                this.resetEmail = '';
                this.isResettingPassword = false;

            } catch (error) {
                // Pega a mensagem de erro da validação (ex: e-mail não encontrado)
                let errorMessage = "Erro ao tentar redefinir a senha.";
                
                if (error.response?.data?.errors?.email) {
                    errorMessage = error.response.data.errors.email[0];
                } else if (error.response?.data?.message) {
                    errorMessage = error.response.data.message;
                }

                this.showAlert(errorMessage, "error");
            } finally {
                this.loadingReset = false;
            }
        }
    }
}
</script>

<style scoped>
.auth-wrapper {
    background-color: #F3F4F6;
    min-height: 100vh;
    width: 100%;
}

.auth-card {
    width: 100%;
    max-width: 900px;
    border: none;
    /* Removemos o min-height daqui */
}

/* Adicionamos a altura mínima diretamente na linha (row) */
.auth-card .row {
    min-height: 550px;
}

.bg-primary-pmg {
    background-color: #e9e9e9;
}

.logo-box-lg {
    background: rgba(255, 255, 255, 0.1);
    width: 80px;
    height: 80px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(5px);
}

.form-control-pmg {
    border-radius: 10px;
    border: 1px solid #E5E7EB;
    padding: 12px;
    font-size: 0.95rem;
    background-color: #F9FAFB;
}

.form-control-pmg:focus {
    border-color: #561569;
    box-shadow: 0 0 0 4px rgba(33, 51, 97, 0.1);
    background-color: #FFF;
}

.input-group-text {
    border: 1px solid #E5E7EB;
}

.btn-pmg-primary {
    background-color: #561569;
    color: white;
    border: none;
    transition: all 0.3s ease;
}

.btn-pmg-primary:hover:not(:disabled) {
    background-color: #1A284C;
    transform: translateY(-1px);
}

.btn-pmg-primary:disabled {
    background-color: #A5ADC1;
    cursor: not-allowed;
}

.text-primary-pmg {
    color: #561569;
}

.x-small {
    font-size: 0.75rem;
}

.fs-7 {
    font-size: 0.85rem;
}

.fs-8 {
    font-size: 0.8rem;
}

.fs-9 {
    font-size: 0.75rem;
}

/* Animação do Erro */
.bg-error-subtle {
    background-color: #fef2f2 !important;
    color: #dc2626 !important;
    border-left: 5px solid #dc2626 !important;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.4s ease;
}

.slide-fade-enter-from {
    transform: translateX(50px);
    opacity: 0;
}

.slide-fade-leave-to {
    opacity: 0;
    transform: scale(0.9);
}
</style>